const isOutOfViewport = elem => {
  if (!elem) return false;

  const bounding = elem.getBoundingClientRect();
  return (
    bounding.bottom >
    (window.innerHeight || document.documentElement.clientHeight)
  );
};

export default isOutOfViewport;
